import store from 'app/store';
import { FuseLoadable } from '@fuse';
import Split from '../../../../split';

export const Index = {
    auth: ['admin', 'sub-admin', 'transport', 'sub-transport', 'producer', 'sub-producer', 'producer_business'],
    routes: [
        {
            path: '/old/pickups/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./raw-milk/admin/old/AdminPickupsApp');
                        case 'transport':
                        case 'sub-transport':
                            return import('./raw-milk/hauling/HaulingPickupsApp');
                        case 'producer':
                        case 'sub-producer':
                            if (store.getState().persisted.auth.user.data.type_of_fluid === 'cream') {
                                return import('./cream/CreamPickupsApp');
                            }
                            return import('./raw-milk/producer/old/ProducerPickupsApp');
                        case 'producer_business':
                            return import('./raw-milk/producer-business/old/ProducerBusinessPickupsApp');
                        default:
                            break;
                    }
                },
            }),
        },
        {
            path: '/pickups/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                return import('./raw-milk/admin/AdminPickupsApp');
                            }
                            return import('./raw-milk/admin/old/AdminPickupsApp');
                        case 'transport':
                        case 'sub-transport':
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                return import('./raw-milk/hauling/HaulingPickupsApp');
                            }
                            return import('./raw-milk/hauling/old/HaulingPickupsApp');
                        case 'producer':
                        case 'sub-producer':
                            if (store.getState().persisted.auth.user.data.type_of_fluid === 'cream') {
                                return import('./cream/CreamPickupsApp');
                            }
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                return import('./raw-milk/producer/ProducerPickupsApp');
                            }
                            return import('./raw-milk/producer/old/ProducerPickupsApp');
                        case 'producer_business':
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                return import('./raw-milk/producer-business/ProducerBusinessPickupsApp');
                            }
                            return import('./raw-milk/producer-business/old/ProducerBusinessPickupsApp');
                        default:
                            break;
                    }
                },
            }),
        },
        {
            path: '/cream-pickups/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                        case 'transport':
                        case 'sub-transport':
                        case 'producer':
                        case 'sub-producer':
                            return import('./cream/CreamPickupsApp');
                        default:
                            break;
                    }
                },
            }),
        },
    ],
};

export default [Index];
